import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import widgetColoringBuilder from 'conversations-internal-schema/coloring/model/WidgetColoring';
import { getOptionLabel, getOptionValue
// @ts-expect-error dependency missing types
} from 'conversations-message-history/quick-reply/operators/quickReplyGetters';
// @ts-expect-error dependency missing types
import QuickReplyGroup from 'conversations-visitor-message-history/quick-reply/QuickReplyGroup';
// @ts-expect-error dependency missing types
import QuickReplySelect from 'conversations-visitor-message-history/quick-reply/QuickReplySelect';
import { Map as ImmutableMap, OrderedSet as ImmutableSet } from 'immutable';
import { useState } from 'react';
import styled from 'styled-components';
import VizExButton from 'visitor-ui-component-library/button/VizExButton';
import { createThemeV2 } from 'visitor-ui-component-library/theme/createThemeV2';
import { OBSIDIAN, WHITE } from 'visitor-ui-component-library/constants/WidgetColors';
import ConsentPromptsOutsideChat from './ConsentPromptsOutsideChat';
import { getCanReadTextOnce } from 'visitor-ui-component-library/utils/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const QuickReplyGroupWrapper = styled.div.withConfig({
  displayName: "QuickReplyGroupOutsideChat__QuickReplyGroupWrapper"
})(["display:flex;justify-content:", ";"], props => props.widgetLocation === 'RIGHT_ALIGNED' ? 'end' : 'start');
const QuickReplySelectContainer = styled.div.withConfig({
  displayName: "QuickReplyGroupOutsideChat__QuickReplySelectContainer"
})(["display:inline-flex;flex-direction:column;align-items:", ";width:240px;"], props => props.widgetLocation === 'RIGHT_ALIGNED' ? 'end' : 'start');
const QuickReplySelectSendButton = styled(VizExButton).withConfig({
  displayName: "QuickReplyGroupOutsideChat__QuickReplySelectSendButton"
})(["margin-top:8px;"]);
const MAX_QUICK_REPLY_BUTTONS_OUTSIDE_CHAT = 4;
export const QuickReplyGroupOutsideChat = ({
  quickReplyOptions = ImmutableSet(),
  widgetLocation = 'RIGHT_ALIGNED',
  onQuickReplyOptionClick = () => {},
  message,
  widgetColoring = widgetColoringBuilder(),
  publishMessage = () => {},
  displayBotQuickRepliesOutsideChat = false,
  consentToProcessMessage,
  cookieConsentPromptMessage,
  consentToProcess,
  showGdprConsentToProcessButton = false,
  closeConsentToProcess,
  showingGdprProcess = false,
  renderCookieConsentPrompt = false,
  consentToCookies,
  isPortal53 = false,
  spamProtectionEnabled
}) => {
  const [selectedQuickReply, setSelectedQuickReply] = useState(ImmutableMap());
  const handleQuickReplyOptionClick = selectedQuickReplyOption => {
    const text = getOptionLabel(selectedQuickReplyOption);
    onQuickReplyOptionClick(text, selectedQuickReplyOption);
  };
  const handleQuickReplyOptionSelect = event => {
    const {
      target: {
        value
      }
    } = event;
    const newSelectedQuickReplyOption = quickReplyOptions.filter(option => getOptionValue(option) === value).first();
    setSelectedQuickReply(newSelectedQuickReplyOption);
  };
  if (!displayBotQuickRepliesOutsideChat) {
    return null;
  }
  const isTextReadable = getCanReadTextOnce(widgetColoring.accentColor);
  const primaryColor = isTextReadable ? widgetColoring.accentColor : OBSIDIAN;
  const textColor = isTextReadable ? widgetColoring.textColor : WHITE;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!renderCookieConsentPrompt && (!showingGdprProcess || !showGdprConsentToProcessButton) && /*#__PURE__*/_jsx(QuickReplyGroupWrapper, {
      widgetLocation: widgetLocation,
      children: quickReplyOptions.size <= MAX_QUICK_REPLY_BUTTONS_OUTSIDE_CHAT ? /*#__PURE__*/_jsx(QuickReplyGroup, {
        "data-test-id": 'quick-reply-group-outside-chat',
        disabled: false,
        options: quickReplyOptions,
        message: message,
        publishMessage: publishMessage,
        onSend: handleQuickReplyOptionClick,
        widgetLocation: widgetLocation,
        isOutsideChat: true,
        accentColor: widgetColoring.accentColor,
        theme: createThemeV2({
          colors: {
            primary: primaryColor
          }
        })
      }) : /*#__PURE__*/_jsxs(QuickReplySelectContainer, {
        "data-test-id": 'quick-reply-select-container-outside-chat',
        widgetLocation: widgetLocation,
        children: [/*#__PURE__*/_jsx(QuickReplySelect, {
          disabled: false,
          quickReplyOptions: quickReplyOptions,
          onChange: handleQuickReplyOptionSelect,
          value: getOptionValue(selectedQuickReply),
          placeholder: I18n.text('conversations-visitor-experience-components.quickReply.selectionPlaceholder'),
          theme: createThemeV2({
            colors: {
              primary: primaryColor
            }
          })
        }), !selectedQuickReply.isEmpty() && /*#__PURE__*/_jsx(QuickReplySelectSendButton, {
          use: 'primary',
          onClick: () => handleQuickReplyOptionClick(selectedQuickReply),
          theme: createThemeV2({
            colors: {
              primary: primaryColor,
              textOnPrimary: textColor
            }
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-visitor-experience-components.quickReply.selectionComplete"
          })
        })]
      })
    }), /*#__PURE__*/_jsx(ConsentPromptsOutsideChat, {
      renderCookieConsentPrompt: renderCookieConsentPrompt,
      cookieConsentPromptMessage: cookieConsentPromptMessage,
      showingGdprProcess: showingGdprProcess,
      consentToProcessMessage: consentToProcessMessage,
      showGdprConsentToProcessButton: showGdprConsentToProcessButton,
      consentToProcess: consentToProcess,
      closeConsentToProcess: closeConsentToProcess,
      consentToCookies: consentToCookies,
      isPortal53: isPortal53,
      spamProtectionEnabled: spamProtectionEnabled
    })]
  });
};
QuickReplyGroupOutsideChat.displayName = 'QuickReplyGroupOutsideChat';
export default QuickReplyGroupOutsideChat;